import React from "react";
import SlideShow from "@core/slideshow/SlideShow";
import ColorButtons from "@core/buttons/electrons/ColorButtons";
import BadgeButton from "@core/buttons/electrons/BadgeButton";

const ProductHeader = ({
                         product,
                         showModal,
                         setShowModal,
                         selectedColor,
                         setSelectedColor,
                         selectedMemory,
                         setSelectedMemory,
                       }) => {

  return (
    <>
      <div className="flex flex-col sm:flex-row">
        <div
          className={`md:flex-4 md:w-1/2 flex justify-center mt-20 lg:mt-0 md:flex-row md:pr-20 md:mb-12`}>
          <SlideShow images={selectedColor.images}/>
        </div>
        <div className="md:flex-2 flex flex-col md:mr-8 md:mt-16 lg:mt-0">
          <div className="font-sans leading-3 font-semibold text-gray-800 text-2xl mt-5 text-center md:text-left">
            {product.name}
          </div>
          <div
            className="font-sans leading-4 font-semibold text-primary underline text-base my-4 text-center md:text-left hover:cursor-pointer"
            onClick={() => setShowModal(!showModal)}>
            Mëso më shumë
          </div>
          <div
            className="font-bold text-lg text-gray-700 font-sans tracking-tight my-5 text-center md:text-left">
            Zgjidh ngjyrën {selectedColor.name && `: ${selectedColor.name}`}
          </div>
          <div className="flex justify-center md:justify-start">
            <ColorButtons selectedColor={selectedColor} colors={product.colors}
                          onClick={(color) => {
              setSelectedColor(color)
              setSelectedMemory(color.memories[0])
            }}/>
          </div>
          <hr className="my-8 w-full md:w-2/3"/>
          <div
            className="font-bold text-lg text-gray-700 font-sans tracking-tight mb-4 text-center md:text-left">Hapësira
          </div>
          <div className="flex justify-center md:justify-start mb-8">
            {selectedColor?.memories?.map((memory) => (
              <BadgeButton selected={selectedMemory?.id === memory.id} description={memory.memory}
                           onClick={() => setSelectedMemory(memory)}/>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductHeader;
